/**
 * Pure resolver for the build-time prototype flag. Lives on its own so both
 * `prototypeMode` and `prototypeOverride` can read it without an import cycle.
 */
const TRUE_VALUE = 'true';
const FALSE_VALUE = 'false';
const PRODUCTION_MODE = 'production';

type PrototypeEnvValue = boolean | string | null | undefined;

const normalize = (value: PrototypeEnvValue) =>
  typeof value === 'string' ? value.trim().toLowerCase() : value;

const defaultPrototypeEnabled = (mode: string | undefined) =>
  (mode ?? '').trim().toLowerCase() !== PRODUCTION_MODE;

export function resolvePrototypeEnabled(
  value: PrototypeEnvValue,
  mode = import.meta.env.MODE
) {
  const normalizedValue = normalize(value);

  if (typeof normalizedValue === 'boolean') {
    return normalizedValue;
  }

  if (!normalizedValue) {
    return defaultPrototypeEnabled(mode);
  }

  if (normalizedValue === TRUE_VALUE) {
    return true;
  }

  if (normalizedValue === FALSE_VALUE) {
    return false;
  }

  return false;
}
